var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',[(_vm.title_no)?_c('span',{staticClass:"num"},[_vm._v(_vm._s(_vm.title_no)+".")]):_vm._e(),_vm._t("title"),_c('span',{staticClass:"attention"},[_vm._t("attention")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }